import React from 'react'

import { reduxForm } from 'redux-form'
import { generateValidation } from 'redux-form-validation'

import cx from 'classnames'

import BaseModal from '../base-modal'
import {
  ModalForm,
  ModalFormRow,
  ModalFormBlock,
  CheckboxGroup
} from '../modal-form/modal-form'

import WorkOrderSelectorContainer from '../../containers/forms/work-order-selector-container'

const validations = {
  workOrderType: { required: true },
  workOrderId: {}
}

const IssueWorkOrderForm = ({
  fields: {
    workOrderType,
    workOrderId
  },
  loading,
  handleSubmit,
  handleClose,
  issue,
  workOrders,
  submitting
}) =>{
  if (loading) return <div>Loading...</div>

  const sendToOpenWorkOrderDisabled = workOrders && workOrders.length == 0

  let workOrderSelect
  if (workOrderType.value === "workOrder") {
    workOrderSelect =
      <ModalFormRow>
        <ModalFormBlock>
          <label htmlFor='workOrderId'>Work Order</label>
          <WorkOrderSelectorContainer
            locationId={issue.location}
            {...workOrderId}
          />
        </ModalFormBlock>
      </ModalFormRow>
  }

  return (
    <BaseModal
      onClose={handleClose}
      title="Send to Work Order"
      contentClassName='work-orders-create-container'
    >
      <ModalForm onSubmit={handleSubmit}>
        <ModalFormRow>
          <ModalFormBlock>
            <CheckboxGroup title="Work Order Type">
              <label key="backlog">
                <input
                  type="radio"
                  {...workOrderType}
                  value="backlog"
                  checked={workOrderType.value === "backlog"}
                />
                <span className='indicator' />
                Send to Backlog
              </label>
              <label
                key="workOrder"
                className={cx({ disabled: sendToOpenWorkOrderDisabled })}
              >
                <input
                  type="radio"
                  {...workOrderType}
                  value="workOrder"
                  checked={workOrderType.value === "workOrder"}
                  disabled={sendToOpenWorkOrderDisabled}
                />
                <span className='indicator' />
                {workOrders && workOrders.length > 0
                  ? "Send to Open Work Order"
                  : "There are no Open Work Orders to send this Issue to"}
              </label>
            </CheckboxGroup>
          </ModalFormBlock>
        </ModalFormRow>

        {workOrderSelect}

        <ModalFormRow>
          <ModalFormBlock submitButton>
            <button
              type='submit'
              disabled={submitting || !workOrderType}
            >
              {submitting ? "Submitting..." : "Submit"}
            </button>
          </ModalFormBlock>
        </ModalFormRow>
      </ModalForm>
    </BaseModal>
  )
}

export default reduxForm({
  form: "issueWorkOrderForm",
  ...generateValidation(validations)
})(IssueWorkOrderForm)



// WEBPACK FOOTER //
// ./src/components/issues/issue-work-order-form.js